import React, { Component } from 'react'
import './index.less'

import score from 'src/helper/score'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'
import lang from '../lang'
import { isVoca } from 'src/helper/tool'

export default class extends Component {
  render() {
    let { kingSupporterData, kingSupporterMyData, lang, language } = this.props
    return (
      <div>
        <div className="last-week" style={{ display: `${kingSupporterData.length > 0 ? 'block' : 'none'}` }}>
          {/* <div className="last-week"> */}
          <div className="title">{lang.lastweek}</div>
          <div className="last-week-rank">
            <div
              className="rank-2"
              onClick={jumpToUser.bind(
                this,
                kingSupporterData && kingSupporterData.length > 1 && kingSupporterData[1].uid
              )}
            >
              <img src="/img/activity/pk/k2.png" alt="" />
            </div>
            <div
              className="rank-1"
              onClick={jumpToUser.bind(
                this,
                kingSupporterData && kingSupporterData.length > 0 && kingSupporterData[0].uid
              )}
            >
              <img src="/img/activity/pk/k1.png" alt="" />
            </div>
            <div
              className="rank-3"
              onClick={jumpToUser.bind(
                this,
                kingSupporterData && kingSupporterData.length > 2 && kingSupporterData[2].uid
              )}
            >
              <img src="/img/activity/pk/k3.png" alt="" />
            </div>
          </div>
          {/* 头像 */}
          <div className="no2">
            <img
              src={(kingSupporterData && kingSupporterData.length > 1 && kingSupporterData[1].avatarurl) || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')}
              alt=""
            />
          </div>
          <div className="no1">
            <img
              src={(kingSupporterData && kingSupporterData.length > 0 && kingSupporterData[0].avatarurl) || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')}
              alt=""
            />
          </div>
          <div className="no3">
            <img
              src={(kingSupporterData && kingSupporterData.length > 2 && kingSupporterData[2].avatarurl) || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')}
              alt=""
            />
          </div>
          {/* 头像 */}

          {/* 信息 */}
          <div className="user-info">
            <div className="user-no2">
              <div className="name">
                {(kingSupporterData && kingSupporterData.length > 1 && kingSupporterData[1].nickname) || ''}
              </div>
              <div className="id">
                ID:{kingSupporterData && kingSupporterData.length > 1 && kingSupporterData[1].duid}
              </div>
              <div className="money">
                <span>{score(kingSupporterData && kingSupporterData.length > 1 && kingSupporterData[1].val)}</span>
                <img src="/img/activity/pk/bs.png" alt="" />
              </div>
            </div>
            <div className="user-no1">
              <div className="name">
                {(kingSupporterData && kingSupporterData.length > 0 && kingSupporterData[0].nickname) || ''}
              </div>
              <div className="id">
                ID:{kingSupporterData && kingSupporterData.length > 0 && kingSupporterData[0].duid}
              </div>
              <div className="money">
                <span>{score(kingSupporterData && kingSupporterData.length > 0 && kingSupporterData[0].val)}</span>
                <img src="/img/activity/pk/bs.png" alt="" />
              </div>
            </div>
            <div className="user-no3">
              <div className="name">
                {(kingSupporterData && kingSupporterData.length > 2 && kingSupporterData[2].nickname) || ''}
              </div>
              <div className="id">
                ID:{kingSupporterData && kingSupporterData.length > 2 && kingSupporterData[2].duid}
              </div>
              <div className="money">
                <span>{score(kingSupporterData && kingSupporterData.length > 2 && kingSupporterData[2].val)}</span>
                <img src="/img/activity/pk/bs.png" alt="" />
              </div>
            </div>
          </div>
          {/* 信息 */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/pkactivity/RankLastWeek/index.js